import {URL_SERVER} from "../../../api/config";
import makeQuery, {descripcionFormatter} from "../../../api/helper";

const defaultState = () => ({
  movimientos: [],
  limite: 30,
  offset: 0,
  currentPage: 1,
  filtros: {
    codigo: "",
    descripcion: "",
    sucursal: "",
    desde: "",
    hasta: "",
  }
})

export default {
  namespaced: true,
  state: defaultState(),
  mutations: {
    "RESET_STATE"(state) {
      Object.assign(state, defaultState())
    },
    "SET_MOVIMIENTOS"(state, payload) {
      state.movimientos = payload
    },
    "SET_KEY_FILTRO"(state, payload) {
      state.filtros[payload.key] = payload.value
    },
    "NEXT_PAGE"(state) {
      state.currentPage++
      state.offset = state.limite * (state.currentPage - 1)
    },
    "BACK_PAGE"(state) {
      state.currentPage--
      state.offset = state.limite * (state.currentPage - 1)
    },
    "RESET_PAGES"(state) {
      state.limite = 30
      state.offset = 0
      state.currentPage = 1
    },
  },
  actions: {
    async getMovimientos({commit, dispatch, state}) {
      try {
        console.log(state.filtros)
        const query = await dispatch("crearQuery")
        const response = await this._vm.$axios.get(`${URL_SERVER}sucursales/historico/movimiento-stock${query}&ordenar_por=createdAt&orden=desc`)
        commit("SET_MOVIMIENTOS", response.data.items)
      } catch (e) {
        console.log(e, "failed to load")
      }
    },
    crearQuery({state}) {
      let filtros = []
      Object.keys(state.filtros).forEach(item => {
        if (item === "codigo" && state.filtros[item] !== "")
          filtros.push({field: "producto.codigo", value: state.filtros[item], operator: "CONTAINS"})
        if (item === "sucursal" && state.filtros[item] !== "")
          filtros.push({field: "sucursal.id", value: state.filtros[item].id, operator: "="})
        if (item === "hasta" && state.filtros[item] !== "")
          filtros.push({field: "createdAt", value: state.filtros[item], operator: "<="})
        if (item === "desde" && state.filtros[item] !== "")
          filtros.push({field: "createdAt", value: state.filtros[item], operator: ">="})
        if (item === "descripcion" && state.filtros[item] !== "") {
          const desc = descripcionFormatter(state.filtros[item], "producto.descripcion")
          filtros.push(...desc)
        }
      })
      return makeQuery({
        filtros: filtros,
        limite: state.limite,
        offset: state.offset
      })
    },


    nextPage({commit, dispatch}) {
      commit("NEXT_PAGE")
      dispatch("getMovimientos")
    },
    backPage({commit, dispatch}) {
      commit("BACK_PAGE")
      dispatch("getMovimientos")
    },
    resetPages({commit, dispatch}) {
      commit("RESET_PAGES")
      dispatch("getMovimientos")
    }
  },
  getters: {
    movimientos: state => state.movimientos,
    currentPage: state => state.currentPage
  }

}
